import { TDevice } from '@cian/utils';

export enum ESiteType {
  desktop = 'desktop',
  mobile = 'mobile',
  tablet = 'tablet',
}

export function getSiteType(deviceType: TDevice) {
  return deviceType === 'phone' ? ESiteType.mobile : ESiteType[deviceType];
}
